/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockFormatLevels.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Block Format Level Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, November 14, 2018 - 01:04:57 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      11/14/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockFormatLevelList = Loadable({
    loader: () => import('../containers/BlockFormatLevels/BlockFormatLevelListContainer'),
    loading: Loading,
});

export const BlockFormatLevelForm = Loadable({
    loader: () => import('../containers/BlockFormatLevels/BlockFormatLevelEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockFormatLevels.js